<script setup lang="ts">
import BackstageIcon from './BackstageIcon.vue';

export interface Props {
  label: string;
  required?: boolean;
  labelFor?: string;
}

withDefaults(defineProps<Props>(), {
  required: false,
});
</script>

<template>
  <div v-bind="$attrs" class="field-new">
    <label v-if="labelFor" :for="labelFor">
      {{ label }}
      <BackstageIcon v-if="required" name="required"></BackstageIcon>
      <slot name="tooltip"></slot>
    </label>
    <span v-else-if="label" class="label">
      {{ label }}
      <BackstageIcon v-if="required" name="required"></BackstageIcon>
      <slot name="tooltip"></slot>
    </span>
    <div class="input-container">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.field-new {
  label,
  span {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

.input-container {
  text-align: left;
}
</style>
